import { useCurrentUser } from '@mp/hooks';
import {
  isAgencyAccount,
  isSaasCredentialingAccount,
  isSaasCredentialingAccountInput,
  isSaasCredentialingAndSchedulingAccount,
  isSaasCredentialingAndSchedulingAccountInput,
} from '@mp/utils';
import React, { PropsWithChildren, ReactElement } from 'react';

type SaasType = 'credentialing' | 'scheduling';

type HideFromProps = PropsWithChildren<{
  saas?: boolean;
  agency?: boolean;
  marketplace?: boolean;
  saasTypes?: SaasType[];
  fallback?: ReactElement;
}>;

export const HideFrom = ({
  saas,
  agency,
  marketplace,
  saasTypes = ['credentialing', 'scheduling'],
  children,
  fallback,
}: HideFromProps) => {
  const {
    currentUser,
    isSaas: isSaasUser,
    isAgency: isAgencyUser,
    isMarketplace,
  } = useCurrentUser();

  const isCredentialingAndScheduling = isSaasCredentialingAndSchedulingAccount(
    currentUser as isSaasCredentialingAndSchedulingAccountInput,
  );
  const isCredentialing = isSaasCredentialingAccount(
    currentUser as isSaasCredentialingAccountInput,
  );
  const isAgency = isAgencyAccount(currentUser);

  if (saas) {
    if (isCredentialingAndScheduling || isCredentialing || isSaasUser) {
      const saasType: SaasType = isCredentialingAndScheduling ? 'scheduling' : 'credentialing';
      if (saasTypes.includes(saasType)) {
        return fallback ?? null;
      }
    }
  }

  if (marketplace && isMarketplace) {
    return fallback ?? null;
  }

  if (agency) {
    if (isAgency || isAgencyUser) {
      return fallback ?? null;
    }
  }

  return <>{children}</>;
};
